import { render, staticRenderFns } from "./scale-screen.vue?vue&type=template&id=798ea194&scoped=true"
import script from "./scale-screen.vue?vue&type=script&lang=js"
export * from "./scale-screen.vue?vue&type=script&lang=js"
import style0 from "./scale-screen.vue?vue&type=style&index=0&id=798ea194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798ea194",
  null
  
)

export default component.exports